import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-loader',
  templateUrl: './image-loader.component.html',
  styleUrls: ['./image-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageLoaderComponent {

  @Input() src = '';
  @Input() class = '';
  @Input() alt = '';
  isImageLoading = true;

  /**
   * Callback function to handle image load success scenario.
   * In this case, only the imageLoading flag is set to false.
   *
   * @memberof ImageLoaderComponent
   */
  onImageLoadSuccess() {
    this.isImageLoading = false;
  }

  /**
   * Callback function to handle image load failure scenario.
   * In this case, imageLoading flag is set to false and
   * the image source path is mapped to default - no image
   *
   * @memberof ImageLoaderComponent
   */
  onImageLoadFailure() {
    this.isImageLoading = false;
    this.src = './assets/image/action/no-img.svg';
  }

}
